import React, { Component } from "react"
import Svg from "../../shared/_svgs/svg"
import axios from "axios"
import * as endpoint from "../../booking/constants/Endpoints"
import { hosts } from "./itinerary-module"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import { trackTravelPlannerInteraction } from "../../helpers/tracking"

export class ItinerarySecurity extends Component {
  constructor(props) {
    super(props)

    this.state = {
      block: props.block,
      flightInfo: props.flightInfo,
      gate: props.gate,
      waitingTime: "N/A",
      airlinesPageLink: props.airlinesPageLink,
      hidePastSteps: props.hidePastSteps,
    }

    this.renderContentBlocks = this.props.renderContentBlocks.bind(this)
    this.showHideContent = this.props.showHideContent.bind(this)
    this.handleClickTracking = this.props.handleClickTracking.bind(this)
  }

  componentDidMount() {
    this.getWaitingTime(this.state.flightInfo && this.state.flightInfo.CheckInTerminal)
  }

  getWaitingTime(terminal) {
    if (terminal.includes("2")) {
      terminal = "t2"
    } else {
      terminal = "t3"
    }

    axios.get(endpoint.WAITING_TIME_SECURITY(hosts)).then(
      (result) => {
        let time = result.data[terminal + "WaitingTimeInterval"] + " min"
        if (result.status === 204) {
          time = "N/A"
        }
        this.setState({
          waitingTime: time,
        })
      },
      (error) => {
        this.setState({
          waitingTime: "N/A",
          error,
        })
      },
    )
  }

  handleAccordionClick = (e) => {
    this.showHideContent(e, ".contentWrapper")
    this.handleAccordionTracking()
  }

  handleAccordionTracking = () => {
    this.setState({ accordionOpen: !this.state.accordionOpen }, () => {
      if (this.state.accordionOpen) {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_open", { fold_title: this.props.block.heading })
      } else {
        trackTravelPlannerInteraction(this.props.tabToggle, "fold_close", { fold_title: this.props.block.heading })
      }
    })
  }

  render() {
    const buttonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonIcon)
    const buttonColor = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.buttonColor)
    const securityButtonSvg = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.securityButtonIcon)
    const theme = SelectionFactoryHelper.getFromSelectionFactory(this.props.block.backgroundColor)
    const hasContentBlocksBeforeText = this.props.block.contentAreaBeforeText?.length > 0
    const hasContentBlocks = this.props.block.contentArea?.length > 0
    const newLink = this.state.airlinesPageLink + "/" + this.state.flightInfo.IataCode

    const style = { "--itinerary-icon": `url(${this.props.block.itineraryIcon ? this.props.block.itineraryIcon : ""})` }

    return (
      <div
        style={this.props.block.itineraryIcon ? style : undefined}
        className={`departure-info__essentials__detailitems__detailitem ${theme ? theme : ""} foldable`}
      >
        <div className={"departure-info__essentials__detailitems__detailitem__header pointer"} onClick={(e) => this.handleAccordionClick(e)}>
          <div className="floatbox">
            <div>{this.state.waitingTime}</div>
          </div>
          <h5>{this.props.block.heading}</h5>
          {this.props.block.subHeading ? <h6>{this.props.block.subHeading}</h6> : ""}
        </div>
        <div className={"contentWrapper show-hide"}>
          <div className={`departure-info__essentials__detailitems__detailitem__infobox`}>
            <div className="grid">
              <div className="grid-item col--12">
                <div className="info-text">
                  {this.props.block.waitingTimeLabel} <span>{this.props.block.expectedLabel}</span>
                </div>
                <h5>{this.state.waitingTime}</h5>
              </div>
            </div>
          </div>
          {hasContentBlocksBeforeText ? this.renderContentBlocks(this.props.block.contentAreaBeforeText) : ""}
          <div className="departure-info__essentials__detailitems__detailitem__infobox__list__view">
            <ul className="grid">
              {this.props.block.uspContainerBlocks && this.props.block.uspContainerBlocks.length > 0
                ? this.props.block.uspContainerBlocks.map((usp, i) => {
                    const uspSvg = SelectionFactoryHelper.getFromSelectionFactory(usp.svgIcon)
                    const icon = usp.iconUpload ? <img src={usp.iconUpload} alt="" /> : uspSvg ? <Svg iconName={uspSvg} /> : ""
                    return (
                      <li key={i} className="grid-item col--12 col-sm--4">
                        {icon}
                        <div className="info-text" dangerouslySetInnerHTML={{ __html: usp.uspText }}></div>
                      </li>
                    )
                  })
                : ""}
            </ul>
            {this.props.block.securityButtonText && this.props.block.securityButtonLink ? (
              <div className="cta-button">
                <a
                  className="button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default"
                  href={this.props.block.securityButtonLink}
                >
                  {securityButtonSvg !== "" ? <Svg iconName={securityButtonSvg} /> : ""}
                  <span className="text">{this.props.block.securityButtonText}</span>
                </a>
              </div>
            ) : (
              ""
            )}
          </div>
          {this.props.block.text || this.props.block.buttonText ? (
            <div className={"textbuttoncontainer"}>
              {this.props.block.text ? <span className="rich-text" dangerouslySetInnerHTML={{ __html: this.props.block.text }}></span> : ""}
              {this.props.block.buttonText && this.props.block.buttonLink ? (
                <div className="cta-button">
                  <a
                    className={`button button--small button--general button__floatbox rm-this-class rm-this-class-hide-default ${
                      buttonColor ? buttonColor : "casc-blue"
                    }`}
                    href={this.props.block.linkToAirlineBool ? newLink : this.props.block.buttonLink}
                    onClick={() => this.handleClickTracking(this.props.block.buttonTracking)}
                  >
                    {buttonSvg !== "" ? <Svg iconName={buttonSvg} /> : ""}
                    <span className="text">{this.props.block.buttonText}</span>
                  </a>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
          {hasContentBlocks ? this.renderContentBlocks(this.props.block.contentArea) : ""}
        </div>
      </div>
    )
  }
}
